function setupAccountDialogPositioning(trigger) {
  customElements.whenDefined('shopify-account').then(() => {
    const dialog = trigger.shadowRoot && trigger.shadowRoot.querySelector('dialog.dialog');
    if (!dialog) return;

    function position() {
      if (!window.matchMedia('(min-width: 750px)').matches) {
        dialog.style.top = '';
        dialog.style.right = '';
        dialog.style.left = '';
        return;
      }
      const rect = trigger.getBoundingClientRect();
      dialog.style.left = 'auto';
      dialog.style.right = (window.innerWidth - rect.right) + 'px';
      dialog.style.top = (rect.bottom + 12) + 'px';
    }

    new MutationObserver(position).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    window.addEventListener('resize', position);
  });
}

const existingTrigger = document.querySelector('shopify-account');
if (existingTrigger) {
  setupAccountDialogPositioning(existingTrigger);
} else {
  // <shopify-account> may not exist in the DOM yet if it's being inserted
  // lazily on hover/focus/touch (see vc-account-lazy-init.js) instead of
  // being server-rendered up front. Watch for it showing up instead of
  // assuming it's already there.
  document.querySelectorAll('[data-account-lazy]').forEach((container) => {
    const observer = new MutationObserver(() => {
      const trigger = container.querySelector('shopify-account');
      if (!trigger) return;
      observer.disconnect();
      setupAccountDialogPositioning(trigger);
    });
    observer.observe(container, { childList: true });
  });
}
